<template>
   <!-- #teleports is the only target Nuxt renders during SSR; others cause hydration mismatches -->
   <Teleport :to="to" :defer="defer">
      <div
         id="modal-wrapper"
         v-if="open"
         :class="[modalType, { fixedHeight, center, large }]"
      >
         <div class="modal">
            <!-- Modal Header -->
            <div class="modal-header">
               <div v-if="!hideClose" class="close" @click="handleClose">
                  <IconCross />
               </div>
               <slot name="header"></slot>
            </div>
            <!-- Modal Content -->
            <div class="modal-body" data-lenis-prevent>
               <slot name="body"></slot>
            </div>
            <!-- Modal Footer -->
            <div class="modal-footer">
               <slot name="footer"></slot>
            </div>
         </div>
      </div>
   </Teleport>
</template>

<script setup lang="ts">
import IconCross from "~/assets/images/icons/cross.svg?component";
const emit = defineEmits(["close"]);
const props = defineProps({
   open: { type: Boolean, default: false },
   center: { type: Boolean, default: false },
   to: { type: String, default: "#teleports" },
   defer: { type: Boolean, default: false },
   large: { type: Boolean, default: false },
   hideClose: { type: Boolean, default: false },
   fixedHeight: { type: Boolean, default: false },
   modalType: {
      type: String,
      validator(value, props) {
         return ["onboarding"].includes(value);
      },
   },
});

const handleClose = () => {
   emit("close");
};
</script>
<style lang="scss">
@import url("~/assets/scss/modal-wrapper.scss");
</style>
